import React, { useRef, useEffect, useState } from "react";
import { Modal, Col, Row } from "react-bootstrap";
import { FormattedMessage, useIntl, injectIntl } from "react-intl";
import { shallowEqual, useDispatch, useSelector, connect } from "react-redux";
import { useHistory } from "react-router-dom";
import { toast } from "react-toastify";

import { useMutation, useLazyQuery } from "@apollo/client";
import {
  Divider,
  Typography,
  Radio,
  RadioGroup,
  FormControlLabel,
  FormControl,
} from "@material-ui/core";
import { Formik } from "formik";

import { setIsShowTNCDialog } from "../../../redux/layout/layoutActions";
import {
  MERGE_ORGANIZATION_REQUEST,
  MERGE_ORGANIZATION,
} from "../../GraphQlCommon/mutation";
import { USER_BY_ID } from "../../GraphQlCommon/query";
import * as auth from "../../Modules/Auth/_redux/authRedux";
import { GET_ORGANIZATIONS } from "../../Pages/Organizations/Graphql/query";
import { TncDialog } from "../../Pages/Selling/seller/screen/TncDialog";
import {
  LOCAL_STORAGE_ROLES,
  ROLE_BUYER,
  ROLE_GUEST,
  TOKEN,
} from "../../Utils/constant";
import { base64Decode } from "../../Utils/helper";
import { SectionLoader } from "../SectionLoader";

import { SIGNUP_PARTICIPANTS } from "./mutation";
import ParticipantSignupLayout from "./ParticipantSignupLayout";
import { useParticipantSignupValidationSchema } from "./useParticipantSignupValidationSchema";

export const ParticipantSignup = ({
  match: {
    params: { id, isInsideRole, organizationId, isGuest, isEmailExist },
  },
}) => {
  const {
    initialValues,
    participantSignupValidationSchema,
  } = useParticipantSignupValidationSchema();

  const ID = base64Decode(id);

  const isInsideRoleTemp = base64Decode(isInsideRole);

  const organizationIdTemp = base64Decode(organizationId);

  const isEmailExistTemp = base64Decode(isEmailExist);

  const isGuestTemp = base64Decode(isGuest);

  const [checked, setChecked] = useState(false);

  const [error, setError] = useState(null);

  const [isModelOpen, SetIsModelOpen] = useState(true);

  const [guest, setGuest] = useState(false);

  const [isOrganizationExist, setIsOrganizationExist] = useState(false);

  const [existingOrganization, setExistingOrganization] = useState(false);

  const [filterOrganization, setFilterOrganization] = useState();

  const [prevCurrentOrg, setPrevCurrentOrg] = useState();

  const [userData, setUserData] = useState();

  const [showMergeContentAlert, setShowMergeContentAlert] = useState(false);

  const [
    showParticipantMergeContentAlert,
    setShowParticipantMergeContentAlert,
  ] = useState(false);

  const [
    showParticipantMergeContentSubmitted,
    setShowParticipantMergeContentSubmitted,
  ] = useState(false);

  const [
    showParticipantMergeContentPositive,
    setShowParticipantMergeContentPositive,
  ] = useState(false);

  const [initialVal, setInitialVal] = useState(initialValues);

  const [tempObj, setTempObj] = useState(null);

  const [value, setValue] = useState();

  const dispatch = useDispatch();

  const formikRef = useRef();

  const history = useHistory();

  const { currentStateAuth } = useSelector(
    state => ({ currentStateAuth: state.auth }),
    shallowEqual,
  );

  const { user } = currentStateAuth;

  const { isShowTNCDialog } = useSelector(
    state => ({ isShowTNCDialog: state.layout.isShowTNCDialog }),
    shallowEqual,
  );

  const handleModelClose = () => {
    if (isModelOpen) {
      SetIsModelOpen(false);
      setShowParticipantMergeContentAlert(false);
      setIsOrganizationExist(false);
      setError(null);
    }

    setTempObj(null);
    setInitialVal(initialValues);
    history.push("/");
  };

  const [
    userSignUp,
    { loading: guestLoading, error: guestError, data: guestData },
  ] = useMutation(SIGNUP_PARTICIPANTS);

  const [
    mergeOrg,
    { loading: mergeOrgLoading, error: mergeOrgError, data: mergeOrgData },
  ] = useMutation(MERGE_ORGANIZATION_REQUEST);

  const [
    mergeOrgFun,
    {
      loading: mergeOrgFunLoading,
      error: mergeOrgFunError,
      data: mergeOrgFunData,
    },
  ] = useMutation(MERGE_ORGANIZATION);

  const [
    getOrganizations,
    {
      loading: organizationsLoading,
      error: organizationsError,
      data: organizationsData,
    },
  ] = useLazyQuery(GET_ORGANIZATIONS, {
    fetchPolicy: "no-cache",
  });

  const [
    userDetailById,
    { error: currentUserError, data: currentUserData },
  ] = useLazyQuery(USER_BY_ID, {
    fetchPolicy: "no-cache",
  });

  useEffect(() => {
    if (currentUserData) {
      const tempData = currentUserData.getUserById;

      setUserData(tempData);
    }

    if (currentUserError) {
      setError(currentUserError.toString().replace("Error: Error:", ""));
    }
  }, [currentUserData, currentUserError]);

  useEffect(() => {
    if (formikRef.current) {
      formikRef.current.setFieldValue("name", userData?.displayName || "");
      formikRef.current.setFieldValue("email", userData?.email || "");
    }
  }, [formikRef.current]);

  useEffect(() => {
    if (user) {
      setInitialVal({
        email: user?.email,
        phone: user?.phoneno,
        password: "",
        changepassword: "",
        name: user?.name,
        comp_name: "",
      });
    }
  }, [user]);

  const listOrganizations = () => {
    if (formikRef?.current?.values.comp_name) {
      if (existingOrganization) setExistingOrganization(null);
      if (filterOrganization) setFilterOrganization(null);
      getOrganizations({
        variables: {
          filter: {
            search: formikRef?.current?.values.comp_name,
            isJoinOrganization: true,
          },
        },
      });
    } else {
      if (existingOrganization) setExistingOrganization(null);
      if (filterOrganization) setFilterOrganization(null);
    }
  };

  // merge org request useEffect
  useEffect(() => {
    if (mergeOrgData) {
      handleModelClose();
      setShowMergeContentAlert(false);
    }

    if (mergeOrgError) {
      setError(mergeOrgError.toString().replace("Error: Error:", ""));
    }
  }, [mergeOrgLoading, mergeOrgData, mergeOrgError]);

  //merge org useEffect
  useEffect(() => {
    if (mergeOrgFunData) {
      handleModelClose();
      setShowMergeContentAlert(false);
    }

    if (mergeOrgFunError) {
      setError(mergeOrgFunError.toString().replace("Error: Error:", ""));
    }
  }, [mergeOrgFunLoading, mergeOrgFunData, mergeOrgFunError]);

  useEffect(() => {
    if (tempObj) {
      setTempObj(null);
    }

    userDetailById({
      variables: {
        userId: ID,
      },
    });
  }, []);

  useEffect(() => {
    if (organizationsData) {
      const { result, count } = organizationsData?.getAllOrganizations;

      if (count > 0) {
        var orgCount = 0;
        var orgData = [];

        for (var i = 0; i < result.length; i++) {
          if (
            result[i].name?.toLowerCase() ===
            formikRef?.current?.values.comp_name.toLowerCase()
          ) {
            orgCount++;
            orgData.push(result[i]);
          }
        }

        // check organization list to user Org list
        const user = JSON.parse(window.localStorage.getItem("user"));

        if (user && user?.userOrg && user?.userOrg?.length > 0) {
          if (orgCount > 0 && orgCount === 1) {
            for (var i = 0; i < user.userOrg.length; i++) {
              if (!user.userOrg[i].isDeleted) {
                if (user.userOrg[i].organization?.id === orgData[0].id) {
                  toast.error(
                    intl.formatMessage({
                      id: "ASSOCIATE.ORGANIZATION.ALERT",
                    }),
                    {
                      position: toast.POSITION.TOP_RIGHT,
                    },
                  );
                  formikRef &&
                    formikRef.current &&
                    formikRef.current.setFieldValue("comp_name", "");
                } else {
                  setExistingOrganization(orgData[0]);
                }
              }
            }
          }

          if (orgCount > 1) {
            setFilterOrganization(orgData);
          } else if (orgCount > 0 && orgCount === 1) {
            setExistingOrganization(orgData[0]);
          }
        } else {
          if (orgCount > 1) {
            setFilterOrganization(orgData);
          } else if (orgCount > 0 && orgCount === 1) {
            setExistingOrganization(orgData[0]);
          }
        }
      }
    }

    if (organizationsError)
      setError(organizationsError.toString().replace("Error: Error:", ""));
  }, [organizationsLoading, organizationsData, organizationsError]);

  useEffect(() => {
    const roles = JSON.parse(window.localStorage.getItem(LOCAL_STORAGE_ROLES));

    if (roles && roles[0] === ROLE_GUEST) {
      setGuest(true);
    } else {
      setGuest(false);
    }
  }, []);

  useEffect(() => {
    if (guestData) {
      let { user, token } = guestData.signUpParticipant;

      window.localStorage.setItem(TOKEN, token);
      window.localStorage.setItem("user", JSON.stringify(user));
      const roles = user?.roles.map(role => role.key);

      window.localStorage.setItem(LOCAL_STORAGE_ROLES, JSON.stringify(roles));
      dispatch(auth.actions.login(token));

      dispatch(
        auth.actions.fulfillUser({
          ...user,
        }),
      );
      if (showParticipantMergeContentPositive) {
        mergeOrgFun({
          variables: {
            orgId: userData?.currentOrganization?.id,
            userId: userData?.id || "",
            mergeOrgId: organizationIdTemp,
          },
        });
      }

      handleModelClose();
      setError(null);
    }

    if (guestError) {
      setError(guestError.toString().replace("Error: Error:", ""));
    }
  }, [guestError, guestData]);

  useEffect(() => {
    if (tempObj) {
      setInitialVal({
        email: tempObj.email || "",
        phone: tempObj.phoneno || "",
        password: tempObj.password || "",
        changepassword: tempObj.changepassword || "",
        name: tempObj.name || "",
        comp_name: tempObj.organizationName || "",
      });

      setError(null);
    }
  }, [tempObj]);

  const intl = useIntl();

  const handleCheckBoxChange = event => {
    setChecked(event.target.checked);
  };

  const handleClickOpen = () => {
    dispatch(setIsShowTNCDialog(true));
  };

  const handleExistingSubmit = isCreateNew => {
    if (existingOrganization) {
      if (isCreateNew) {
        userSignUp({
          variables: {
            email: tempObj?.email,
            phoneno: tempObj?.phoneno,
            password: tempObj?.password,
            name: tempObj?.name,
            organizationName: tempObj?.organizationName,
            roleKey: ROLE_BUYER,
          },
        });
      } else {
        userSignUp({
          variables: {
            email: tempObj?.email,
            phoneno: tempObj?.phoneno,
            password: tempObj?.password,
            name: tempObj?.name,
            organizationId: existingOrganization ? existingOrganization.id : "",
            roleKey: ROLE_BUYER,
          },
        });
      }

      setPrevCurrentOrg(user?.currentOrganization?.id);
    } else {
      if (filterOrganization) {
        toast.error(intl.formatMessage({ id: "ERROR.SELECT.ORGANIZATION" }), {
          position: toast.POSITION.TOP_RIGHT,
        });
      }
    }
  };

  const showLocationWithOrg = item => {
    if (item?.locations && item.locations?.length > 0) {
      return `${item.name} (${item.locations[0].cityName},${item.locations[0].stateName})`;
    } else {
      return `${item.name}`;
    }
  };

  const handleYesSubmit = () => {
    const user = JSON.parse(window.localStorage.getItem("user"));

    if (user) {
      if (!guest) {
        mergeOrg({
          variables: {
            orgId: prevCurrentOrg || "",
            userId: user?.id || "",
            mergeOrgId:
              existingOrganization?.id || user?.currentOrganization?.id,
          },
        });
      } else {
        mergeOrgFun({
          variables: {
            orgId: prevCurrentOrg || "",
            mergeOrgId:
              existingOrganization?.id || user?.currentOrganization?.id,
            userId: user?.id || "",
          },
        });
      }
    }
  };

  const handleNoSubmit = () => {
    handleModelClose();
    setShowMergeContentAlert(false);
  };

  const renderExistingLayout = () => {
    if (showMergeContentAlert) {
      return (
        <>
          <Typography>
            Do you wish to merge your existing individual data into the new
            organization?
          </Typography>
          <br />
          <br />

          <Typography>
            <b>Note:</b> Merging data into the new organization will have
            followning impact-
            <br />
            <br />
            <ul>
              <li>
                Your individual notes & list will be moved to private notes
              </li>
              <li>
                If you are doing a negotiation on an asset on which the company
                is already negotiating, all your deals & conversation specific
                to that asset will be lost
              </li>
            </ul>
          </Typography>
        </>
      );
    } else if (showParticipantMergeContentAlert) {
      return (
        <>
          <Typography>
            Do you wish to merge your existing individual data into the new
            organization?
          </Typography>
          <br />
          <br />
        </>
      );
    } else if (filterOrganization) {
      const OrgData = filterOrganization;

      const filteredOrgLocList = [];

      for (let i = 0; i < OrgData.length; i++) {
        let primaryLoc = OrgData[i].locations;

        if (primaryLoc.length > 0) {
          for (let j = 0; j < primaryLoc.length; j++) {
            if (primaryLoc[j].isPrimary === true) {
              filteredOrgLocList.push(OrgData[i]);
            }
          }
        } else {
          filteredOrgLocList.push(OrgData[i]);
        }
      }

      return (
        <>
          <Typography>
            {
              "There are multiple Companies in our system with the Company Name you have chosen. You can join one of these organization & click the \"Join Organization\" button. You'll then be verified by the Company Admin. If you do not want to join the existing organization, please click on \"Create New Organization\" button."
            }
          </Typography>{" "}
          <FormControl component="fieldset">
            <RadioGroup
              aria-label="org"
              name="org"
              value={value}
              onChange={handleChange}
            >
              <div>
                {filteredOrgLocList.map((item, index) => {
                  return (
                    <FormControlLabel
                      id={index}
                      value={item.id}
                      control={<Radio />}
                      label={showLocationWithOrg(item)}
                    />
                  );
                })}
              </div>
            </RadioGroup>
          </FormControl>
        </>
      );
    } else if (existingOrganization) {
      return (
        <div className="mb-10">
          <Typography>
            {`${tempObj?.organizationName} Company Name exists in our system. You can join this organization by clicking "Join Organization" button. You'll then be verified by the Company Admin. If you do not want to join the existing organization, please click on "Create New Organization" button. `}
          </Typography>
        </div>
      );
    }
  };

  const handleChange = event => {
    setValue(event.target.value);
    setExistingOrganization({ id: event.target.value });
  };

  const handleBack = () => {
    setIsOrganizationExist(false);
    if (error) setError(null);
  };

  const renderLayout = (
    values,
    errors,
    touched,
    handleChange,
    handleSubmit,
  ) => {
    return (
      <ParticipantSignupLayout
        values={values}
        errors={errors}
        touched={touched}
        handleChange={handleChange}
        handleSubmit={handleSubmit}
        isEmailExistTemp={isEmailExistTemp}
        isGuestTemp={isGuestTemp}
        isInsideRoleTemp={isInsideRoleTemp}
        setError={setError}
        error={error}
        listOrganizations={listOrganizations}
        showParticipantMergeContentSubmitted={
          showParticipantMergeContentSubmitted
        }
        setShowParticipantMergeContentAlert={
          setShowParticipantMergeContentAlert
        }
        showParticipantMergeContentPositive={
          showParticipantMergeContentPositive
        }
        userData={userData}
        handleModelClose={handleModelClose}
        handleClickOpen={handleClickOpen}
        handleCheckBoxChange={handleCheckBoxChange}
        checked={checked}
      />
    );
  };

  return (
    <>
      <SectionLoader
        loader={
          guestLoading ||
          organizationsLoading ||
          mergeOrgLoading ||
          mergeOrgFunLoading
        }
      />

      <Modal
        show={isModelOpen}
        onHide={handleModelClose}
        aria-labelledby="example-modal-sizes-title-lg"
        centered
        backdrop="static"
      >
        <Modal.Header>
          <Modal.Title>Complete Your Profile</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <>
            {error && (
              <div className="mb-10 alert alert-custom alert-light-danger alert-dismissible">
                <div className="alert-text font-weight-bold">{error}</div>
              </div>
            )}
            {!isOrganizationExist &&
            !showMergeContentAlert &&
            !showParticipantMergeContentAlert ? (
                <>
                  <Formik
                    innerRef={formikRef}
                    enableReinitialize={true}
                    initialValues={initialVal}
                    validationSchema={participantSignupValidationSchema}
                    onSubmit={(values, { setSubmitting }) => {
                      if (checked) {
                        if (!existingOrganization && !filterOrganization) {
                          userSignUp({
                            variables: {
                              email: values.email,
                              phoneno: values.phone,
                              password: values.password,
                              name: values.name,
                              organizationName: values.comp_name,
                            },
                          });
                        } else {
                          setIsOrganizationExist(true);
                          setTempObj({
                            name: values.name,
                            email: values.email,
                            phoneno: values.phone,
                            password: values.password,
                            organizationName: values.comp_name,
                            changepassword: values.changepassword,
                          });
                        }
                      } else {
                        toast.error("Please accept Term and condition", {
                          position: toast.POSITION.TOP_RIGHT,
                        });
                        setSubmitting(false);
                      }
                    }}
                  >
                    {({
                      handleSubmit,
                      handleChange,
                      values,
                      errors,
                      touched,
                    }) => (
                      <>
                        {renderLayout(
                          values,
                          errors,
                          touched,
                          handleChange,
                          handleSubmit,
                        )}
                      </>
                    )}
                  </Formik>
                  <Divider light />
                </>
              ) : (
                <>
                  {renderExistingLayout()}
                  <Row>
                    <Col md="12" className="customModalFooter mb-5">
                      <Modal.Footer>
                        {showMergeContentAlert ? (
                          <>
                            <button
                              type="button"
                              onClick={handleYesSubmit}
                              className="btn btn-primary btn-elevate"
                            >
                            Yes
                            </button>
                            <button
                              type="button"
                              onClick={handleNoSubmit}
                              className="btn btn-primary btn-elevate"
                            >
                            No
                            </button>
                          </>
                        ) : showParticipantMergeContentAlert ? (
                          <>
                            <button
                              type="button"
                              onClick={() => {
                                setShowParticipantMergeContentAlert(false);
                                setShowParticipantMergeContentPositive(true);
                                setShowParticipantMergeContentSubmitted(true);
                              }}
                              className="btn btn-primary btn-elevate"
                            >
                            Yes
                            </button>
                            <button
                              type="button"
                              onClick={() => {
                                setShowParticipantMergeContentAlert(false);
                                setShowParticipantMergeContentPositive(false);
                                setShowParticipantMergeContentSubmitted(true);
                              }}
                              className="btn btn-primary btn-elevate"
                            >
                            No
                            </button>
                          </>
                        ) : (
                          <>
                            <button
                              type="submit"
                              onClick={handleBack}
                              className="btn btn-primary btn-elevate"
                            >
                            Go Back
                            </button>
                            <button
                              type="submit"
                              onClick={() => {
                                handleExistingSubmit(false);
                              }}
                              className="btn btn-primary btn-elevate"
                            >
                              <FormattedMessage id="GLOBAL.JOIN.ORG" />
                            </button>
                            <button
                              type="submit"
                              onClick={() => {
                                handleExistingSubmit(true);
                              }}
                              className="btn btn-primary btn-elevate mt-5"
                            >
                              <FormattedMessage id="GLOBAL.CREATE.NEW.ORG" />
                            </button>
                          </>
                        )}
                      </Modal.Footer>
                    </Col>
                  </Row>
                </>
              )}
            {isShowTNCDialog && <TncDialog />}
          </>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default injectIntl(connect(null, null)(ParticipantSignup));
